import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import{ GlobalConstants } from '../common/global';
import { Services } from "src/app/services/api.service"
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  constructor(private httpClient: HttpClient, public Services: Services) { }

  ngOnInit() {
    //this.isUserLoggedIn();
  }

  async isUserLoggedIn() {        
    if(localStorage.getItem('accessToken' + environment.connId) !== null) {
      return true;
    } else {
      return false;
    }
  }
}
